<div class="header-wrapper">
  <div class="btn-group">
    <app-button
      [kind]="buttonOption.kind"
      [icon]="buttonOption.icon"
      (clicked)="switchInOffice(true)"
      [appTooltip]="'Translation.In-office' | translate"
      [tooltipPosition]="'bottomRight'"
      [tooltipTheme]="'white'"
    >
    </app-button>
    <!--Phase1- Commenting Virtual section as it is not required.  -->
    <!-- <app-button
      [kind]="buttonOptionVirtual.kind"
      [icon]="buttonOptionVirtual.icon"
      [isDisabled]="IsCAMemberFirm"
      (clicked)="switchInOffice(false)"
      [appTooltip]="'Translation.Virtual' | translate"
      [tooltipPosition]="'bottomRight'"
      [tooltipTheme]="'white'"
    >
    </app-button> -->
  </div>
</div>
